var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 144.36,
    height: 71.197,
    viewBox: "0 0 144.36 71.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 144.36,
    height: 71.197,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_49",
    "data-name": "Groupe 49",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_103",
    "data-name": "Trac\\xE9 103",
    d: "M26.389,13.348,17.652,63.41H28.869l.865-4.839H23.286l7.942-45.223Z",
    transform: "translate(-4.002 -3.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_104",
    "data-name": "Trac\\xE9 104",
    d: "M46.717,18.373l.867-4.838h-5.4l-.972,4.84Z",
    transform: "translate(-9.345 -3.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_36",
    "data-name": "Groupe 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_35",
    "data-name": "Groupe 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_105",
    "data-name": "Trac\\xE9 105",
    d: "M120.5,44.149a11.3,11.3,0,0,0,2.022-2.529,8.969,8.969,0,0,0,1.118-3.067l3.034-17.188a7.7,7.7,0,0,0-.071-3.143,6.254,6.254,0,0,0-1.264-2.563,6.865,6.865,0,0,0-2.276-1.734,8.33,8.33,0,0,0-3.033-.578H90.923L84.858,47.653l-4.19-34.306H75.83L66.947,63.9h4.838l6.067-34.3,4.19,34.3H86.88l8.034-45.715h4.442L91.266,63.9H96.1L104.2,18.185h5.6L101.758,63.9H106.6l2.887-16.536L113.818,63.9h5.416l-4.549-17.188a8.4,8.4,0,0,0,3.105-.757,9.848,9.848,0,0,0,2.708-1.806m-5.525-2.274h-4.549l4.186-23.76h4.551a2.692,2.692,0,0,1,2.168.942,2.76,2.76,0,0,1,.577,2.317L118.8,38.615a3.7,3.7,0,0,1-1.335,2.318,3.782,3.782,0,0,1-2.492.942",
    transform: "translate(-15.179 -3.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_106",
    "data-name": "Trac\\xE9 106",
    d: "M155.2,59.063H142.917L146.1,41.081h12.28l.868-4.84H146.962l3.176-18.054H162.42l.865-4.768-17.263-.07L137.139,63.9h17.19Z",
    transform: "translate(-31.093 -3.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_107",
    "data-name": "Trac\\xE9 107",
    d: "M40.656,63.911,46.84,46.438l7.032-20.006L53.8,63.911h4.839l.145-50.55H53.51L45.5,36.244H38.513l-1.662,4.839h6.956l-7.99,22.828Z",
    transform: "translate(-8.121 -3.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_108",
    "data-name": "Trac\\xE9 108",
    d: "M10.28,45l.994-5.555,5.936-33.9h14.1L32.3.081,12.486,0,0,71.2H19.731l1-5.554H6.632Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_109",
    "data-name": "Trac\\xE9 109",
    d: "M157.484,0l-1,5.554h14.1l-3.647,20.639-.994,5.555L160,65.644h-14.1l-.994,5.473,19.814.08L177.215,0Z",
    transform: "translate(-32.855 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_110",
    "data-name": "Trac\\xE9 110",
    d: "M37.756,90.444l73.4-.08.994-5.473H38.754Z",
    transform: "translate(-8.56 -19.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_111",
    "data-name": "Trac\\xE9 111",
    d: "M44.1,5.5h.518L45.487.608h.9L46.478.09H44.166l-.094.518h.9Z",
    transform: "translate(-9.992 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_112",
    "data-name": "Trac\\xE9 112",
    d: "M51.4,4.985H50.111l.34-1.925h1.043l.094-.518H50.545L50.885.608h1.291L52.268.1,50.444.09,49.492,5.5h1.819Z",
    transform: "translate(-11.221 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_113",
    "data-name": "Trac\\xE9 113",
    d: "M55.642,5.24a.69.69,0,0,0,.243.186.753.753,0,0,0,.325.07h.139a.911.911,0,0,0,.349-.07A1.138,1.138,0,0,0,57,5.24a1.077,1.077,0,0,0,.237-.275.97.97,0,0,0,.128-.336l.109-.619H56.96l-.109.619a.424.424,0,0,1-.41.348H56.3a.285.285,0,0,1-.232-.1.293.293,0,0,1-.063-.247l.65-3.673A.391.391,0,0,1,56.8.709a.405.405,0,0,1,.266-.1h.14a.287.287,0,0,1,.231.1A.292.292,0,0,1,57.5.956l-.108.619h.52l.107-.619A.8.8,0,0,0,58.011.62a.669.669,0,0,0-.136-.275A.689.689,0,0,0,57.632.16a.752.752,0,0,0-.326-.07h-.138a.9.9,0,0,0-.347.07,1.123,1.123,0,0,0-.309.186,1.077,1.077,0,0,0-.237.275.987.987,0,0,0-.128.336L55.5,4.629a.8.8,0,0,0,.008.336.651.651,0,0,0,.136.275",
    transform: "translate(-12.58 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M62,3.059h.835L62.406,5.5h.517l.434-2.444.092-.518L63.883.1h-.518l-.442,2.444h-.835L62.522.09H62L61.053,5.5h.517Z",
    transform: "translate(-13.842 -0.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M68.24,1.83,68.688,5.5h.518L70.157.09H69.64l-.65,3.673L68.542.09h-.518L67.072,5.5h.518Z",
    transform: "translate(-15.207 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_116",
    "data-name": "Trac\\xE9 116",
    d: "M73.62,5.24a.71.71,0,0,0,.244.186.743.743,0,0,0,.325.07h.139a.912.912,0,0,0,.347-.07,1.171,1.171,0,0,0,.309-.186,1.122,1.122,0,0,0,.236-.275.956.956,0,0,0,.128-.336L76,.956A.844.844,0,0,0,75.991.62a.679.679,0,0,0-.136-.275A.7.7,0,0,0,75.612.16a.753.753,0,0,0-.325-.07h-.139A.911.911,0,0,0,74.8.16a1.183,1.183,0,0,0-.309.186,1.105,1.105,0,0,0-.236.275.924.924,0,0,0-.127.336l-.65,3.673a.817.817,0,0,0,.008.336.677.677,0,0,0,.135.275M74.638.956A.394.394,0,0,1,74.78.709a.4.4,0,0,1,.267-.1h.139a.289.289,0,0,1,.233.1.3.3,0,0,1,.062.247l-.65,3.673a.426.426,0,0,1-.411.348h-.139a.29.29,0,0,1-.233-.1.3.3,0,0,1-.06-.247Z",
    transform: "translate(-16.656 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_117",
    "data-name": "Trac\\xE9 117",
    d: "M83.029,6.48H79.457l-.086.479h3.573Z",
    transform: "translate(-17.996 -1.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_118",
    "data-name": "Trac\\xE9 118",
    d: "M88.074,5.433a1.147,1.147,0,0,0,.309-.186,1.06,1.06,0,0,0,.236-.275.956.956,0,0,0,.128-.336l.216-1.23a.817.817,0,0,0-.008-.336.682.682,0,0,0-.131-.275,1,1,0,0,0,.356-.611L89.4.956A.816.816,0,0,0,89.39.62a.66.66,0,0,0-.136-.275A.689.689,0,0,0,89.011.16a.753.753,0,0,0-.325-.07H87.672L86.721,5.5h1.006a.906.906,0,0,0,.347-.07M88.114.608h.48a.284.284,0,0,1,.23.1.293.293,0,0,1,.063.247l-.217,1.23a.4.4,0,0,1-.143.247.406.406,0,0,1-.268.1h-.486ZM87.68,3.052h.488a.29.29,0,0,1,.233.1.3.3,0,0,1,.06.249l-.223,1.234a.4.4,0,0,1-.144.249.408.408,0,0,1-.266.1H87.34Z",
    transform: "translate(-19.662 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_119",
    "data-name": "Trac\\xE9 119",
    d: "M93.2,4.428h1.028V5.5h.518L94.762.09H94.2L92.3,5.5h.518ZM94.234,1.49l-.008,2.42h-.843Z",
    transform: "translate(-20.927 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_120",
    "data-name": "Trac\\xE9 120",
    d: "M99.618,3.73l.466,1.771h.58l-.488-1.84a.909.909,0,0,0,.332-.081,1.033,1.033,0,0,0,.29-.193,1.216,1.216,0,0,0,.217-.271.955.955,0,0,0,.121-.329l.325-1.84a.844.844,0,0,0-.008-.336.66.66,0,0,0-.136-.275.7.7,0,0,0-.243-.186.753.753,0,0,0-.325-.07V.088H99.742L98.791,5.5h.52ZM100.168.6h.486a.29.29,0,0,1,.233.1.3.3,0,0,1,.062.248l-.332,1.846a.4.4,0,0,1-.143.249.406.406,0,0,1-.268.1H99.72Z",
    transform: "translate(-22.398 -0.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_121",
    "data-name": "Trac\\xE9 121",
    d: "M108.529,6.48h-3.572l-.086.479h3.573Z",
    transform: "translate(-23.777 -1.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_122",
    "data-name": "Trac\\xE9 122",
    d: "M112.37,5.24a.71.71,0,0,0,.244.186.743.743,0,0,0,.325.07h.139a.909.909,0,0,0,.347-.07,1.175,1.175,0,0,0,.31-.186,1.119,1.119,0,0,0,.235-.275.956.956,0,0,0,.128-.336l.107-.619h-.518l-.107.619a.424.424,0,0,1-.411.348h-.139a.285.285,0,0,1-.292-.348l.649-3.673a.392.392,0,0,1,.142-.247.4.4,0,0,1,.268-.1h.138a.289.289,0,0,1,.233.1.3.3,0,0,1,.062.247l-.108.619h.518l.108-.619a.816.816,0,0,0-.008-.336.678.678,0,0,0-.135-.275.707.707,0,0,0-.244-.186.751.751,0,0,0-.325-.07H113.9a.915.915,0,0,0-.35.07,1.2,1.2,0,0,0-.309.186A1.122,1.122,0,0,0,113,.62a.938.938,0,0,0-.127.336l-.65,3.673a.817.817,0,0,0,.008.336.677.677,0,0,0,.135.275",
    transform: "translate(-25.442 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_123",
    "data-name": "Trac\\xE9 123",
    d: "M119.692,4.985h-1.307L119.251.09h-.518L117.781,5.5H119.6Z",
    transform: "translate(-26.704 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_124",
    "data-name": "Trac\\xE9 124",
    d: "M123.491,5.248a.718.718,0,0,0,.243.186.755.755,0,0,0,.326.07h.139a.909.909,0,0,0,.347-.07,1.188,1.188,0,0,0,.31-.186,1.119,1.119,0,0,0,.235-.275.957.957,0,0,0,.128-.336l.8-4.547h-.518l-.8,4.547a.4.4,0,0,1-.143.247.406.406,0,0,1-.268.1h-.139a.29.29,0,0,1-.233-.1.294.294,0,0,1-.06-.247l.8-4.547h-.518l-.8,4.547a.816.816,0,0,0,.009.336.658.658,0,0,0,.135.275",
    transform: "translate(-27.963 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125",
    "data-name": "Trac\\xE9 125",
    d: "M130.445,5.433a1.2,1.2,0,0,0,.309-.186,1.122,1.122,0,0,0,.236-.275.924.924,0,0,0,.127-.336l.217-1.23a.816.816,0,0,0-.008-.336A.682.682,0,0,0,131.2,2.8a1,1,0,0,0,.355-.611l.217-1.23a.816.816,0,0,0-.008-.336.677.677,0,0,0-.135-.275A.71.71,0,0,0,131.38.16a.743.743,0,0,0-.325-.07h-1.012L129.092,5.5H130.1a.912.912,0,0,0,.347-.07m.039-4.825h.479a.287.287,0,0,1,.232.1.3.3,0,0,1,.063.247l-.218,1.23a.393.393,0,0,1-.143.247.4.4,0,0,1-.266.1h-.488Zm-.434,2.444h.486a.29.29,0,0,1,.233.1.3.3,0,0,1,.062.249l-.225,1.234a.4.4,0,0,1-.142.249.409.409,0,0,1-.268.1h-.486Z",
    transform: "translate(-29.268 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_126",
    "data-name": "Trac\\xE9 126",
    d: "M138.83,6.48h-3.573l-.084.479h3.572Z",
    transform: "translate(-30.647 -1.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_127",
    "data-name": "Trac\\xE9 127",
    d: "M143.875,5.433a1.2,1.2,0,0,0,.309-.186,1.136,1.136,0,0,0,.236-.275.924.924,0,0,0,.127-.336L145.2.964a.815.815,0,0,0-.008-.336.677.677,0,0,0-.135-.275.71.71,0,0,0-.244-.186.743.743,0,0,0-.325-.07L144.478.09h-1L142.522,5.5h1.006a.912.912,0,0,0,.347-.07m.03-4.817h.488a.29.29,0,0,1,.233.1.3.3,0,0,1,.062.247l-.659,3.673a.391.391,0,0,1-.142.247.41.41,0,0,1-.268.1h-.488Z",
    transform: "translate(-32.313 -0.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_128",
    "data-name": "Trac\\xE9 128",
    d: "M148.35,5.238a.724.724,0,0,0,.244.186.746.746,0,0,0,.325.07h.14a.915.915,0,0,0,.347-.07,1.2,1.2,0,0,0,.31-.186,1.153,1.153,0,0,0,.235-.275.971.971,0,0,0,.128-.336l.8-4.547h-1.128L149.676.6h.6l-.711,4.028a.424.424,0,0,1-.411.349h-.138a.287.287,0,0,1-.232-.1.293.293,0,0,1-.062-.247l.107-.619h-.517l-.108.619a.8.8,0,0,0,.009.336.656.656,0,0,0,.134.275",
    transform: "translate(-33.599 -0.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_129",
    "data-name": "Trac\\xE9 129",
    d: "M154.45,5.24a.71.71,0,0,0,.244.186.743.743,0,0,0,.325.07h.139a.909.909,0,0,0,.347-.07,1.175,1.175,0,0,0,.31-.186,1.12,1.12,0,0,0,.235-.275.956.956,0,0,0,.128-.336l.186-1.044a.752.752,0,0,0-.028-.394.679.679,0,0,0-.22-.309l-.743-.6a.264.264,0,0,1-.092-.286l.186-1.036a.392.392,0,0,1,.142-.247.406.406,0,0,1,.268-.1h.138a.289.289,0,0,1,.233.1.3.3,0,0,1,.062.247l-.108.619h.518l.108-.619a.816.816,0,0,0-.008-.336.678.678,0,0,0-.135-.275.707.707,0,0,0-.244-.186.751.751,0,0,0-.325-.07h-.138a.915.915,0,0,0-.35.07,1.2,1.2,0,0,0-.309.186,1.121,1.121,0,0,0-.236.275.939.939,0,0,0-.127.336L154.772,2a.76.76,0,0,0,.027.394.679.679,0,0,0,.22.309l.742.6a.262.262,0,0,1,.094.286l-.186,1.036a.4.4,0,0,1-.143.247.406.406,0,0,1-.268.1h-.139a.285.285,0,0,1-.231-.1.29.29,0,0,1-.062-.247l.107-.619h-.518l-.107.619a.817.817,0,0,0,.008.336.677.677,0,0,0,.135.275",
    transform: "translate(-34.982 -0.021)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo_header.ef0512a3f999517ed473261c17066b30.svg";
export { ForwardRef as ReactComponent };